// Helper type for CSS class strings or arrays of strings
type SlotClassDefinition = string | string[]

interface BlogPostsVariants {
	orientation?: {
		horizontal?: SlotClassDefinition
		vertical?: SlotClassDefinition
	}
	// Add other variant groups here if needed
}

export interface ExtendedBlogPostsThemeConfig {
	base?: SlotClassDefinition
	variants?: BlogPostsVariants
}

export default {
	base: 'flex flex-col gap-8 lg:gap-y-16',
	variants: {
		orientation: {
			horizontal: 'sm:grid sm:grid-cols-2 lg:grid-cols-3 px-4',
			vertical: ''
		}
	}
} satisfies ExtendedBlogPostsThemeConfig
